export const defaultSelectStyle = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    borderColor: '#adb5bd',
    color: '#494949',
  }),
  option: (styles) => ({ minHeight: '2.5rem', ...styles }), //for empty option
  input: (styles) => ({ ...styles }),
  placeholder: (styles) => ({ ...styles, color: '#494949' }),
  dropdownIndicator: (styles) => ({ ...styles, color: '#797979', '&:hover': { color: '#494949' } }),
};
